// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"5fba1e5e","605":"6ad29ebb"}[chunkId] + ".chunk.css";
};